import React,{useReducer,useState} from 'react'
import './Topup.scss'
import crown from '../../assets/crown.png'
import {faTimes} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '../button/Button'
import gopay from '../../assets/gopay.png'
import ovo from '../../assets/ovo.png'
import atmbersama from '../../assets/atmbersama.png'
import indomaret from '../../assets/indomaret.png'


const initialState = {
    hargaGopay : 'Rp. 11.000',
    hargaOvo : 'Rp. 11.000',
    hargaAtm : 'Rp. 10.500',
    hargaIndo : 'Rp. 12.000',
}
const reducer = (state,action) => {
    switch(action.type) {
        case 'harga2' :
            return {...state,hargaGopay: 'Rp. 21.000',hargaOvo:'Rp. 21.000',hargaAtm : 'Rp. 20.000',hargaIndo: 'Rp. 22.500'}
        case 'harga3' :
            return {...state,hargaGopay: 'Rp. 32.000',hargaOvo:'Rp. 32.000',hargaAtm : 'Rp. 30.000',hargaIndo: 'Rp. 32.500'}
        case 'harga4' :
            return {...state,hargaGopay: 'Rp. 41.000',hargaOvo:'Rp. 41.000',hargaAtm : 'Rp. 40.000',hargaIndo: 'Rp. 42.500'}
        case 'harga5' :
            return {...state,hargaGopay: 'Rp. 52.000',hargaOvo:'Rp. 52.000',hargaAtm : 'Rp. 50.000',hargaIndo: 'Rp. 52.500'}
        case 'harga6' :
            return {...state,hargaGopay: 'Rp. 61.000',hargaOvo:'Rp. 61.000',hargaAtm : 'Rp. 60.000',hargaIndo: 'Rp. 62.500'}
        case 'harga7' :
            return {...state,hargaGopay: 'Rp. 72.000',hargaOvo:'Rp. 72.000',hargaAtm : 'Rp. 70.000',hargaIndo: 'Rp. 72.500'}
        case 'harga8' :
            return {...state,hargaGopay: 'Rp. 81.000',hargaOvo:'Rp. 81.000',hargaAtm : 'Rp. 80.000',hargaIndo: 'Rp. 82.500'}
        case 'harga9' :
            return {...state,hargaGopay: 'Rp. 92.000',hargaOvo:'Rp. 92.000',hargaAtm : 'Rp. 90.000',hargaIndo: 'Rp. 92.500'}
        case 'harga1' :
            return initialState
        default :
            return initialState
    }
}

const Topup = ({onClose}) => {

    const TokenBuy = ({onClick,className,price}) => {
        return (
            <>
                <div className={className} onClick={onClick}>
                    <img src={crown} alt="crown"/>
                    <p>{price}</p>
                </div>
            </>
        )
    }

    const TokenPay = ({onClick,className,gambar,detail}) => {
        return (
            <>
                <div className={className} onClick={onClick}>
                    <div className="method-pay-logo">
                        <img src={gambar} alt={gambar}/>
                    </div>
                    <div className="method-pay-price">
                        <p>{detail}</p>
                    </div>
                </div>
            </>
        )
    }

    const [harga,dispatch] = useReducer(reducer,initialState)

    const [act,setAct] = useState({
        activeObject : null,
        objects : [
            {id:1,pr:100,dis:'harga1'},
            {id:2,pr:250,dis:'harga2'},
            {id:3,pr:500,dis:'harga3'},
            {id:4,pr:1000,dis:'harga4'},
            {id:5,pr:2500,dis:'harga5'},
            {id:6,pr:5000,dis:'harga6'},
            {id:7,pr:10000,dis:'harga7'},
            {id:8,pr:15000,dis:'harga8'},
            {id:9,pr:20000,dis:'harga9'}
        ]
    })

    function toggleActive(i) {
        setAct({...act, activeObject : act.objects[i]})
    }

    function toggleActiveStyles(i) {
        if (act.objects[i] === act.activeObject) {
            return "token-box active"
        } else {
            return "token-box inactive"
        }
    }

    const [pay,setPay] = useState({
        activeObject : null,
        objects : [
            {id:1,gambar:gopay,detail:harga.hargaGopay},
            {id:2,gambar:ovo,detail:harga.hargaOvo},
            {id:3,gambar:atmbersama,detail:harga.hargaAtm},
            {id:4,gambar:indomaret,detail:harga.hargaIndo},
        ]
    })

    function togglePay(i) {
        setPay({...pay, activeObject : pay.objects[i]})
    }

    function togglePayStyle(i) {
        if (pay.objects[i] === pay.activeObject) {
            return "method-for-pay active"
        } else {
            return "method-for-pay inactive"
        }
    }

    return (
        <>
            <div className="topup__container">
                <div className="topup__container-wrap">

                    <div className="topup__container-closetag">
                        <div className="topup__container-closetag-wrap" onClick={onClose}>
                            <FontAwesomeIcon icon={faTimes} size='lg' className="close"/>
                        </div>
                    </div>

                    <div className="topup__container-header">
                        <h1>Topup</h1>
                    </div>

                    <div className="topup__payment-section">
                        <div className="topup__payment-token">
                            <div className="token-user">
                                <p>Your Throne:</p>
                                <div className="token-user-amount">
                                    <img src={crown} alt="crown"/>
                                    <p>0</p>
                                </div>
                            </div>
                            <div className="token-buy">
                                <p>Amount</p>
                                <div className="token-buy-amount">
                                    {act.objects.map((objects,i) => (
                                        <TokenBuy 
                                            key ={i}
                                            className = {toggleActiveStyles(i)}
                                            price = {objects.pr}
                                            onClick = {() => {
                                                toggleActive(i)
                                                dispatch({type : `${objects.dis}`})
                                            }}
                                        />   
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="line-mark"></div>

                        <div className="topup__payment-method">
                            <div className="payment-method-header">
                                <p>Payment Method</p>
                            </div>
                            <div className="payment-method-choose">
                                {pay.objects.map((objects,i) => (
                                    <TokenPay
                                        key={i}
                                        className = {togglePayStyle(i)}
                                        onClick = {() => {togglePay(i)}}
                                        gambar = {objects.gambar}
                                        detail = {harga.hargaGopay}
                                    />
                                ))}
                            </div>

                            <div className="payment-method-button">
                                <Button buttonColor="green" buttonSize="btn--wide">PAY</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Topup
